<template>
  <section>

    <b-row>
      <b-col md="12">
        <h2>Solicitudes de desautorización</h2>
      </b-col>
    </b-row>

    <div class="mt-4">

      <b-modal v-model="modalDesautoriza" size="lg" no-close-on-backdrop>

        <b-col v-if="!cargandoRegistrosTotales">

          <p class="my-4">
            Se solicitará la desautorización para {{seleccionados.length }} registros.
            Desea continuar con el proceso de solicitud ?
          </p>

          <div class="mt-4" v-if=" insertRegistros.estado != null && !insertRegistros.estado">
            <!-- <b-alert class="mb-2" variant="danger" show>Error de carga</b-alert> -->
            <p>
              Se encontraron los siguientes errores
            </p>
          </div>

          <div class="mt-2" v-if=" insertRegistros.estado != null && !insertRegistros.estado && !(insertRegistros.cruces != null && insertRegistros.cruces.length > 0 )">
            <b-alert variant="danger" show>Error al registrar en base de datos</b-alert>
          </div>

          <div class="mt-2" v-if=" insertRegistros.cruces != null && insertRegistros.cruces.length > 0">
            <b-alert variant="danger" show>Registros repetidos o repetición de solicitudes</b-alert>
          </div>

        </b-col>
        <b-col class="text-center" v-else>
          <br><br><br><br>
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
          <br><br><br><br>
        </b-col>

        <template #modal-footer="{ cancel }">
          <b-button variant="warning" @click="limpiarErrores()" v-if="insertRegistros.estado != null && !insertRegistros.estado">
            Limpiar errores
          </b-button>
          <b-button variant="danger" @click="solicitarDesautorizacionFinal()" v-if="!cargandoRegistrosTotales">
            Solicitar desautorización
          </b-button>
          <b-button variant="info" @click="cancel()" v-if="!cargandoRegistrosTotales">
            Cancelar
          </b-button>
        </template>

      </b-modal>

      <!-- Modal de eliminar solicitud -->
      <b-modal v-model="modalGeneradas" size="lg" no-close-on-backdrop>

        <b-col>

          <p class="my-4">
            Se eliminarán {{seleccionados.length }} solicitudes realizadas.
            Desea continuar con el proceso de eliminación ?
          </p>

        </b-col>

        <template #modal-footer="{ cancel }">
          <b-button variant="danger" @click="solicitarCancelacion()">
            Eliminar solicitudes
          </b-button>
          <b-button variant="info" @click="cancel()">
            Cancelar
          </b-button>
        </template>

      </b-modal>

      <b-tabs content-class="p-3" v-model="tabActual">

        <!-- Estudiantes -->
        <b-tab title="Estudiantes" v-if="$auth.can('solicitar_autorizacion_estudiante') || $auth.can('solicitar_autorizacion_todos')">
          <b-row>
            <b-col md="6">
              <b-form-group label="Fecha:" label-for="input-filtro-fecha-desde-est">
                <b-input-group>
                  <b-input id="input-filtro-fecha-desde-est" placeholder="Desde" v-model="filtroEstudiante.desde"></b-input>
                  <b-datepicker :initial-date="hoy" v-model="filtroEstudiante.desde" button-only show-decade-nav></b-datepicker>
                  <b-input class="ml-4" placeholder="Hasta" v-model="filtroEstudiante.hasta"></b-input>
                  <b-datepicker :initial-date="hoy" v-model="filtroEstudiante.hasta" show-decade-nav button-only></b-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group label="Codigo:" label-for="input-codigo-est">
                <b-form-input id="input-codigo-est" type="text" v-model="filtroEstudiante.codigo"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="NRC:" label-for="input-periodo-est">
                <div class="input-group">
                  <b-form-input id="input-periodo-est" placeholder="Periodo" type="text" v-model="filtroEstudiante.periodo" :state="checkNrc"></b-form-input>
                  <b-form-input id="input-nrc-est" placeholder="NRC" type="text" v-model="filtroEstudiante.nrc" :state="checkNrc"></b-form-input>
                </div>
              </b-form-group>
            </b-col>

            <!-- <b-col md="4">
              <b-form-group label="DIA:" label-for="input-filtro-nombre">
                <b-form-input id="input-dia-est" type="text" v-model="diaBusquedaEst"></b-form-input>
              </b-form-group>
            </b-col> -->

          </b-row>

          <b-row class="mt-2 mb-4" v-if="!cargandoEstudiantes">

            <b-col>
              <b-button class="mr-2" md="12" variant="primary" @click="cargarDatosBusqueda('ESTUDIANTE')">
                Buscar autorizaciones
              </b-button>

              <b-button class="mr-2" variant="info" @click="checkAll('ESTUDIANTE')" v-if="registrosEstudiantes.length > 0">
                Seleccionar todo
              </b-button>

              <b-button class="mr-2" variant="info" @click="uncheckAll('ESTUDIANTE')" v-if="registrosEstudiantes.length > 0">
                Deseleccionar todo
              </b-button>

              <b-button class="mr-2" variant="danger" @click="solicitarDesautorizacion('ESTUDIANTE')" v-if="registrosEstudiantes.length > 0">
                Solicitar desautorización
              </b-button>

            </b-col>

          </b-row>

          <div v-if="!cargandoEstudiantes">

            <div v-if="registrosEstudiantes.length > 0">
              <b-table responsive striped hover :items="registrosEstudiantes" :fields="camposAutorizaciones" caption-top>
                <template #table-caption>{{registrosEstudiantes.length + ' registros'}}</template>
                <template #cell(SELECCION) class="d-flex justify-content-center">
                  <input type="checkbox" name="ESTUDIANTE">
                </template>
                <template #cell(NOMBRE)="row">
                  <div>{{row.item.NOMBRE}}</div>
                </template>
                <template #cell(fecha_inicio)="row">
                  <div>{{ eliminarHoraFecha( row.item.fecha_inicio ) }}</div>
                </template>
                <template #cell(fecha_fin)="row">
                  <div>{{ eliminarHoraFecha( row.item.fecha_fin ) }}</div>
                </template>
                <template #cell(dia)="row">
                  <div>{{ dias[row.item.dia-1]}}</div>
                </template>
              </b-table>
            </div>

            <div v-else>
              <b-alert show>No se encontraron autorizaciones</b-alert>
            </div>

          </div>

          <div class="text-center" v-else>
            <br><br><br><br>
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
            <br><br><br><br>
          </div>

        </b-tab>

        <!-- Profesores -->
        <b-tab title="Docentes" v-if="$auth.can('solicitar_autorizacion_profesor') || $auth.can('solicitar_autorizacion_todos')">
          <b-row>
            <b-col md="6">
              <b-form-group label="Fecha:" label-for="input-filtro-fecha-desde-doc">
                <b-input-group>
                  <b-input id="input-filtro-fecha-desde-doc" placeholder="Desde" v-model="filtroDocente.desde"></b-input>
                  <b-datepicker :initial-date="hoy" v-model="filtroDocente.desde" button-only show-decade-nav></b-datepicker>
                  <b-input class="ml-4" placeholder="Hasta" v-model="filtroDocente.hasta"></b-input>
                  <b-datepicker :initial-date="hoy" v-model="filtroDocente.hasta" show-decade-nav button-only></b-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>

            <b-col md="6">
              <b-form-group label="Codigo:" label-for="input-codigo-doc">
                <b-form-input id="input-codigo-doc" type="text" v-model="filtroDocente.codigo"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="NRC:" label-for="input-periodo-doc">
                <div class="input-group">
                  <b-form-input id="input-periodo-doc" placeholder="Periodo" type="text" v-model="filtroDocente.periodo" :state="checkNrc"></b-form-input>
                  <b-form-input id="input-nrc-doc" placeholder="NRC" type="text" v-model="filtroDocente.nrc" :state="checkNrc"></b-form-input>
                </div>
              </b-form-group>
            </b-col>

            <!-- <b-col md="4">
              <b-form-group label="DIA:" label-for="input-filtro-nombre">
                <b-form-input id="input-dia-doc" type="text" v-model="diaBusquedaDoc"></b-form-input>
              </b-form-group>
            </b-col> -->

          </b-row>

          <b-row class="mt-2 mb-4" v-if="!cargandoDocentes">

            <b-col>
              <b-button class="mr-2" md="12" variant="primary" @click="cargarDatosBusqueda('DOCENTE')">
                Buscar autorizaciones
              </b-button>

              <b-button class="mr-2" variant="info" @click="checkAll('DOCENTE')" v-if="registrosDocentes.length > 0">
                Seleccionar todo
              </b-button>

              <b-button class="mr-2" variant="info" @click="uncheckAll('DOCENTE')" v-if="registrosDocentes.length > 0">
                Deseleccionar todo
              </b-button>

              <b-button class="mr-2" variant="danger" @click="solicitarDesautorizacion('DOCENTE')" v-if="registrosDocentes.length > 0">
                Solicitar desautorización
              </b-button>

            </b-col>

          </b-row>

          <div v-if="!cargandoDocentes">

            <div v-if="registrosDocentes.length > 0">
              <b-table responsive striped hover :items="registrosDocentes" :fields="camposAutorizaciones" tabindex="1" caption-top>
                <template #table-caption>{{registrosDocentes.length + ' registros'}}</template>
                <template #cell(NOMBRE)="row">
                  <div>{{row.item.NOMBRE}}</div>
                </template>
                <template #cell(SELECCION) class="d-flex justify-content-center">
                  <input type="checkbox" name="DOCENTE">
                </template>
                <template #cell(fecha_inicio)="row">
                  <div>{{ eliminarHoraFecha( row.item.fecha_inicio ) }}</div>
                </template>
                <template #cell(fecha_fin)="row">
                  <div>{{ eliminarHoraFecha( row.item.fecha_fin ) }}</div>
                </template>
                <template #cell(dia)="row">
                  <div>{{ dias[row.item.dia-1]}}</div>
                </template>
              </b-table>
            </div>

            <div v-else>
              <b-alert show>No se encontraron autorizaciones</b-alert>
            </div>

          </div>

          <div class="text-center" v-else>
            <br><br><br><br>
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
            <br><br><br><br>
          </div>
        </b-tab>

        <!-- Empleados -->
        <b-tab title="Empleados" v-if="$auth.can('solicitar_autorizacion_empleado') || $auth.can('solicitar_autorizacion_todos')">
          <b-row>
            <b-col md="6">
              <b-form-group label="Fecha:" label-for="input-filtro-fecha-desde-emp">
                <b-input-group>
                  <b-input id="input-filtro-fecha-desde-emp" placeholder="Desde" v-model="filtroEmpleado.desde"></b-input>
                  <b-datepicker :initial-date="hoy" v-model="filtroEmpleado.desde" button-only show-decade-nav></b-datepicker>
                  <b-input class="ml-4" placeholder="Hasta" v-model="filtroEmpleado.hasta"></b-input>
                  <b-datepicker :initial-date="hoy" v-model="filtroEmpleado.hasta" show-decade-nav button-only></b-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Codigo:" label-for="input-codigo-emp">
                <b-form-input id="input-codigo-emp" type="text" v-model="filtroEmpleado.codigo"></b-form-input>
              </b-form-group>
            </b-col>

          </b-row>

          <b-row class="mt-2 mb-4" v-if="!cargandoEmpleados">

            <b-col>
              <b-button class="mr-2" md="12" variant="primary" @click="cargarDatosBusqueda('EMPLEADO')">
                Buscar autorizaciones
              </b-button>

              <b-button class="mr-2" variant="info" @click="checkAll('EMPLEADO')" v-if="registrosEmpleados.length > 0">
                Seleccionar todo
              </b-button>

              <b-button class="mr-2" variant="info" @click="uncheckAll('EMPLEADO')" v-if="registrosEmpleados.length > 0">
                Deseleccionar todo
              </b-button>

              <b-button class="mr-2" variant="danger" @click="solicitarDesautorizacion('EMPLEADO')" v-if="registrosEmpleados.length > 0">
                Solicitar desautorización
              </b-button>

            </b-col>

          </b-row>

          <div v-if="!cargandoEmpleados">

            <div v-if="registrosEmpleados.length > 0">
              <b-table responsive striped hover :items="registrosEmpleados" :fields="camposAutorizaciones" tabindex="1" caption-top>
                <template #table-caption>{{registrosEmpleados.length + ' registros'}}</template>
                <template #cell(NOMBRE)="row">
                  <div>{{row.item.NOMBRE}}</div>
                </template>
                <template #cell(SELECCION) class="d-flex justify-content-center">
                  <input type="checkbox" name="EMPLEADO">
                </template>
                <template #cell(fecha_inicio)="row">
                  <div>{{ eliminarHoraFecha( row.item.fecha_inicio ) }}</div>
                </template>
                <template #cell(fecha_fin)="row">
                  <div>{{ eliminarHoraFecha( row.item.fecha_fin ) }}</div>
                </template>
                <template #cell(dia)="row">
                  <div>{{ dias[row.item.dia-1]}}</div>
                </template>
              </b-table>
            </div>

            <div v-else>
              <b-alert show>No se encontraron autorizaciones</b-alert>
            </div>

          </div>

          <div class="text-center" v-else>
            <br><br><br><br>
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
            <br><br><br><br>
          </div>
        </b-tab>

        <!-- Especiales -->
        <b-tab title="Especiales" v-if="$auth.can('solicitar_autorizacion_especial') || $auth.can('solicitar_autorizacion_todos')">
          <b-row>
            <b-col md="6">
              <b-form-group label="Fecha:" label-for="input-filtro-fecha-desde-esp">
                <b-input-group>
                  <b-input id="input-filtro-fecha-desde-esp" placeholder="Desde" v-model="filtroEspecial.desde"></b-input>
                  <b-datepicker :initial-date="hoy" v-model="filtroEspecial.desde" button-only show-decade-nav></b-datepicker>
                  <b-input class="ml-4" placeholder="Hasta" v-model="filtroEspecial.hasta"></b-input>
                  <b-datepicker :initial-date="hoy" v-model="filtroEspecial.hasta" show-decade-nav button-only></b-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Codigo:" label-for="input-codigo-esp">
                <b-form-input id="input-codigo-esp" type="text" v-model="filtroEspecial.codigo"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mt-2 mb-4" v-if="!cargandoEspeciales">

            <b-col>
              <b-button class="mr-2" md="12" variant="primary" @click="cargarDatosBusqueda('ESPECIAL')">
                Buscar autorizaciones
              </b-button>

              <b-button class="mr-2" variant="info" @click="checkAll('ESPECIAL')" v-if="registrosEspeciales.length > 0">
                Seleccionar todo
              </b-button>

              <b-button class="mr-2" variant="info" @click="uncheckAll('ESPECIAL')" v-if="registrosEspeciales.length > 0">
                Deseleccionar todo
              </b-button>

              <b-button class="mr-2" variant="danger" @click="solicitarDesautorizacion('ESPECIAL')" v-if="registrosEspeciales.length > 0">
                Solicitar desautorización
              </b-button>

            </b-col>

          </b-row>

          <div v-if="!cargandoEspeciales">

            <div v-if="registrosEspeciales.length > 0">
              <b-table responsive striped hover :items="registrosEspeciales" :fields="camposAutorizaciones" tabindex="1" caption-top>
                <template #table-caption>{{registrosEspeciales.length + ' registros'}}</template>
                <template #cell(NOMBRE)="row">
                  <div>{{row.item.NOMBRE}}</div>
                </template>
                <template #cell(SELECCION) class="d-flex justify-content-center">
                  <input type="checkbox" name="ESPECIAL">
                </template>
                <template #cell(fecha_inicio)="row">
                  <div>{{ eliminarHoraFecha( row.item.fecha_inicio ) }}</div>
                </template>
                <template #cell(fecha_fin)="row">
                  <div>{{ eliminarHoraFecha( row.item.fecha_fin ) }}</div>
                </template>
                <template #cell(dia)="row">
                  <div>{{ dias[row.item.dia-1]}}</div>
                </template>
              </b-table>
            </div>

            <div v-else>
              <b-alert show>No se encontraron autorizaciones</b-alert>
            </div>

          </div>

          <div class="text-center" v-else>
            <br><br><br><br>
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
            <br><br><br><br>
          </div>
        </b-tab>

        <!-- Visitantes -->
        <b-tab title="Visitantes" v-if="$auth.can('solicitar_autorizacion_visitante') || $auth.can('solicitar_autorizacion_todos')">
          <b-row>
            <b-col md="6">
              <b-form-group label="Fecha:" label-for="input-filtro-fecha-desde-Vis">
                <b-input-group>
                  <b-input id="input-filtro-fecha-desde-Vis" placeholder="Desde" v-model="filtroVisitante.desde"></b-input>
                  <b-datepicker :initial-date="hoy" v-model="filtroVisitante.desde" button-only show-decade-nav></b-datepicker>
                  <b-input class="ml-4" placeholder="Hasta" v-model="filtroVisitante.hasta"></b-input>
                  <b-datepicker :initial-date="hoy" v-model="filtroVisitante.hasta" show-decade-nav button-only></b-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Codigo:" label-for="input-codigo-vis">
                <b-form-input id="input-codigo-Vis" type="text" v-model="filtroVisitante.codigo"></b-form-input>
              </b-form-group>
            </b-col>

          </b-row>

          <b-row class="mt-2 mb-4" v-if="!cargandoVisitantes">

            <b-col>
              <b-button class="mr-2" md="12" variant="primary" @click="cargarDatosBusqueda('VISITANTE')">
                Buscar autorizaciones
              </b-button>

              <b-button class="mr-2" variant="info" @click="checkAll('VISITANTE')" v-if="registrosVisitantes.length > 0">
                Seleccionar todo
              </b-button>

              <b-button class="mr-2" variant="info" @click="uncheckAll('VISITANTE')" v-if="registrosVisitantes.length > 0">
                Deseleccionar todo
              </b-button>

              <b-button class="mr-2" variant="danger" @click="solicitarDesautorizacion('VISITANTE')" v-if="registrosVisitantes.length > 0">
                Solicitar desautorización
              </b-button>

            </b-col>

          </b-row>

          <div v-if="!cargandoVisitantes">

            <div v-if="registrosVisitantes.length > 0">
              <b-table responsive striped hover :items="registrosVisitantes" :fields="camposAutorizaciones" tabindex="1" caption-top>
                <template #table-caption>{{registrosVisitantes.length + ' registros'}}</template>
                <template #cell(NOMBRE)="row">
                  <div>{{row.item.NOMBRE}}</div>
                </template>
                <template #cell(SELECCION) class="d-flex justify-content-center">
                  <input type="checkbox" name="VISITANTE">
                </template>
                <template #cell(fecha_inicio)="row">
                  <div>{{ eliminarHoraFecha( row.item.fecha_inicio ) }}</div>
                </template>
                <template #cell(fecha_fin)="row">
                  <div>{{ eliminarHoraFecha( row.item.fecha_fin ) }}</div>
                </template>
                <template #cell(dia)="row">
                  <div>{{ dias[row.item.dia-1]}}</div>
                </template>
              </b-table>
            </div>

            <div v-else>
              <b-alert show>No se encontraron autorizaciones</b-alert>
            </div>

          </div>

          <div class="text-center" v-else>
            <br><br><br><br>
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
            <br><br><br><br>
          </div>
        </b-tab>

        <!-- Solicitudes generadas -->
        <b-tab title="Solicitudes generadas" v-if="$auth.can('solicitar_autorizacion_estudiante') || $auth.can('solicitar_autorizacion_profesor') ||  $auth.can('solicitar_autorizacion_todos') ">
          <b-row>
            <b-col md="6">
              <b-form-group label="Fecha:" label-for="input-filtro-fecha-desde-gen">
                <b-input-group>
                  <b-input id="input-filtro-fecha-desde-gen" placeholder="Desde" v-model="filtroGeneradas.desde"></b-input>
                  <b-datepicker :initial-date="hoy" v-model="filtroGeneradas.desde" button-only show-decade-nav></b-datepicker>
                  <b-input class="ml-4" placeholder="Hasta" v-model="filtroGeneradas.hasta"></b-input>
                  <b-datepicker :initial-date="hoy" v-model="filtroGeneradas.hasta" show-decade-nav button-only></b-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>

            <b-col md="6">
              <b-form-group label="Codigo:" label-for="input-codigo-gen">
                <b-form-input id="input-codigo-gen" type="text" v-model="filtroGeneradas.codigo"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="NRC:" label-for="input-periodo-gen">
                <div class="input-group">
                  <b-form-input id="input-periodo-gen" placeholder="Periodo" type="text" v-model="filtroGeneradas.periodo" :state="checkNrc"></b-form-input>
                  <b-form-input id="input-nrc-gen" placeholder="NRC" type="text" v-model="filtroGeneradas.nrc" :state="checkNrc"></b-form-input>
                </div>
              </b-form-group>
            </b-col>

          </b-row>

          <b-row class="mt-2 mb-4" v-if="!cargandoGeneradas">

            <b-col>
              <b-button class="mr-2" md="12" variant="primary" @click="cargarDatosBusqueda('GENERADAS')">
                Buscar solicitudes
              </b-button>

              <b-button class="mr-2" variant="info" @click="checkAll('GENERADAS')" v-if="registrosGeneradas.length > 0">
                Seleccionar todo
              </b-button>

              <b-button class="mr-2" variant="info" @click="uncheckAll('GENERADAS')" v-if="registrosGeneradas.length > 0">
                Deseleccionar todo
              </b-button>

              <b-button class="mr-2" variant="danger" @click="solicitarDesautorizacion('GENERADAS')" v-if="registrosGeneradas.length > 0">
                Cancelar solicitud
              </b-button>
            </b-col>

          </b-row>

          <div v-if="!cargandoGeneradas">

            <div v-if="registrosGeneradas.length > 0">
              <b-table responsive striped hover :items="registrosGeneradas" :fields="camposAutorizaciones" tabindex="1" caption-top>
                <template #table-caption>{{ registrosGeneradas.length + ' registros' }}</template>
                <template #cell(NOMBRE)="row">
                  <div>{{row.item.NOMBRE}}</div>
                </template>
                <template #cell(SELECCION) class="d-flex justify-content-center">
                  <input type="checkbox" name="GENERADAS">
                </template>
                <template #cell(fecha_inicio)="row">
                  <div>{{ eliminarHoraFecha( row.item.fecha_inicio ) }}</div>
                </template>
                <template #cell(fecha_fin)="row">
                  <div>{{ eliminarHoraFecha( row.item.fecha_fin ) }}</div>
                </template>
              </b-table>
            </div>

            <div v-else>
              <b-alert show>No se encontraron autorizaciones</b-alert>
            </div>

          </div>

          <div class="text-center" v-else>
            <br><br><br><br>
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
            <br><br><br><br>
          </div>

        </b-tab>

      </b-tabs>

    </div>

  </section>
</template>

<script lang="ts">
import { Vue, Component, Watch } from 'vue-property-decorator'
import axios from 'axios'
import { url } from '../../../services/url_service'
import { DateTimeFormatter, LocalDate } from '@js-joda/core'

@Component
export default class SolicitudesAutorizacion extends Vue {

  public dias: Array<any> = [
    'LUNES',
    'MARTES',
    'MIERCOLES',
    'JUEVES',
    'VIERNES',
    'SABADO',
    'DOMINGO',
  ]

  public seleccionados: Array<any> = []
  public fecha_inicio: string = ""
  public fecha_fin: string = ""

  public registrosEstudiantes: Array<any> = []
  public registrosDocentes: Array<any> = []
  public registrosEmpleados: Array<any> = []
  public registrosEspeciales: Array<any> = []
  public registrosVisitantes: Array<any> = []

  public registrosGeneradas: Array<any> = []

  public cargandoEstudiantes = false;
  public cargandoDocentes = false;
  public cargandoEmpleados = false;
  public cargandoEspeciales = false;
  public cargandoVisitantes = false;

  public cargandoRegistrosTotales = false;
  public cargandoRegistrosTotalesDesautoriza = false;

  public cargandoGeneradas = false;

  public datosGenerador: any = {}

  public page: number = 1
  public limit: number = 10
  public count: number = 0

  //public filtros: any = {}
  public orden: any = {
    columna: 'fecha_inicio',
    direccion: 'ASC',
  }

  public pageErrores: number = 1
  public limitErrores: number = 10
  public countErrores: number = 0
  public errores: Array<any> = []

  public filtroEstudiante: any = {}
  public filtroDocente: any = {}
  public filtroEmpleado: any = {}
  public filtroEspecial: any = {}
  public filtroVisitante: any = {}
  public filtroGeneradas: any = {}

  public tabActual: number = 0
  public rollActual: string = ""

  // Iniciales
  public botonActivado: boolean = false
  public showOverlay: boolean = false


  // Datos de quien solicita
  public personalData: any = {}
  public persona: any = {
    codigo: '',
    rol: '',
    nombre: '',
    programa: '',
    autorizado: '',
    horario: [],
    temperatura: '',
    observaciones: '',
  }

  public insertRegistros: any = {
    estado: null,
    cruces: null,
    alertas: null,
    limite_aforo: null,
  }

  public modalDesautoriza: boolean = false
  public modalGeneradas: boolean = false

  public camposAutorizaciones: Array<any> = [
    {
      key: 'SELECCION',
      label: 'Selección',
    },
    {
      key: 'id',
      label: 'Id',
    },
    {
      key: 'codigo',
      label: 'Código',
    },
    {
      key: 'nombre',
      label: 'Nombre',
    },
    {
      key: 'materia',
      label: 'Materia',
    },
    {
      key: 'periodo',
      label: 'Periodo',
    },
    {
      key: 'nrc',
      label: 'Nrc',
    },
    {
      key: 'asignatura',
      label: 'Asignatura/Motivo',
    },
    {
      key: 'ubicacion',
      label: 'Ubicación',
    },
    {
      key: 'fecha_inicio',
      label: 'Fecha de inicio',
    },
    {
      key: 'fecha_fin',
      label: 'Fecha Final',
    },
    {
      key: 'dia',
      label: 'Dia',
    },
    {
      key: 'hora_entrada',
      label: 'Hora de entrada',
    },
    {
      key: 'hora_salida',
      label: 'Hora de salida',
    },
  ]

  public checkNrc: boolean = null

  get diaUno(): string {
    return LocalDate.of(LocalDate.now().year(), 1, 1).format(DateTimeFormatter.ISO_LOCAL_DATE)
  }

  get hoy(): string {
    return LocalDate.now().format(DateTimeFormatter.ISO_LOCAL_DATE)
  }

  @Watch('tabActual')
  public onTabChange(value, oldValue) {
    if (oldValue != value) {
      this.checkNrc = null
    }
  }

  public eliminarHoraFecha(fecha) {
    var fechaFinalSinHora = fecha.substring(0, fecha.indexOf(' '));
    return fechaFinalSinHora;
  }

  public checkAll(registroTipo) {
    var items = document.getElementsByName(registroTipo);
    for (var i = 0; i < items.length; i++) {
      if (items[i].type == 'checkbox')
        items[i].checked = true;
    }
  }

  public uncheckAll(registroTipo) {
    var items = document.getElementsByName(registroTipo);
    for (var i = 0; i < items.length; i++) {
      if (items[i].type == 'checkbox')
        items[i].checked = false;
    }
  }

  public solicitarDesautorizacion(registroTipo) {

    this.limpiarErrores();

    var registros = [];
    this.seleccionados = [];

    this.fecha_inicio = "";
    this.fecha_fin = "";

    this.rollActual = registroTipo;


    if (registroTipo == "ESTUDIANTE") {
      registros = this.registrosEstudiantes;

    } else if (registroTipo == "DOCENTE") {
      registros = this.registrosDocentes;

    } else if (registroTipo == "EMPLEADO") {
      registros = this.registrosEmpleados;

    } else if (registroTipo == "ESPECIAL") {
      registros = this.registrosEspeciales;

    } else if (registroTipo == "VISITANTE") {
      registros = this.registrosVisitantes;

    } else if (registroTipo == "GENERADAS") {
      registros = this.registrosGeneradas;
    }


    var items = document.getElementsByName(registroTipo);
    for (var i = 0; i < items.length; i++) {
      if (items[i].type == 'checkbox') {
        if (items[i].checked == true) {

          if (registroTipo == 'GENERADAS') {
            this.modalGeneradas = true;
            this.seleccionados.push(registros[i])
          } else {

            this.modalDesautoriza = true;
            this.limpiarErrores();
            this.seleccionados.push(registros[i])

          }

        }
      }
    }

  }

  public limpiarErrores() {
    this.insertRegistros = {
      estado: null,
      cruces: null,
      alertas: null,
      limite_aforo: null,
    };
  }

  // Funcion que llama a la api para hacer la carga final de los archivos
  public async solicitarDesautorizacionFinal() {

    this.limpiarErrores();
    this.cargandoRegistrosTotales = true;

    var autorizadorCompleto = this.$auth.can('solicitar_autorizacion_todos');
    var arregloSeleccion = this.seleccionados;

    if (this.datosGenerador.CODIGO == null) {
      if (autorizadorCompleto) {
        this.datosGenerador.CODIGO = "ADMIN"
      } else {

        this.cargandoRegistrosTotales = false;
        this.$bvToast.toast(
          'El usuario actual no cuenta con los permisos suficientes o no se ha encontrado una identificación válida',
          {
            title: 'Error al solicitar',
            variant: 'danger',
            autoHideDelay: 5000,
          }
        )

        this.modalDesautoriza = false;
        return;

      }
    }

    let response = await axios.post(
      url.create('/internal/solicitudes'),
      {
        "registros": arregloSeleccion,
        "admin": autorizadorCompleto,
        "fechaInicio": this.fecha_inicio.toString(),
        "fechaFin": this.fecha_fin.toString(),
        "datosGenerador": this.datosGenerador,
        "tipoRoll": this.rollActual,
        "tipoSolicitud": 'DESAUTORIZA',
      }
    );

    this.insertRegistros = response.data;


    if (this.insertRegistros.estado) {
      this.limpiarErrores();

      this.modalDesautoriza = false;
      this.$bvToast.toast(
        'Se ha realizado la solicitud de los registros seleccionados exitosamente',
        {
          title: 'Registros cargados',
          variant: 'success',
          autoHideDelay: 5000,
        }
      )

    } else { }

    this.cargandoRegistrosTotales = false;


  }


  public async solicitarCancelacion() {

    this.modalGeneradas = false;

    var autorizadorCompleto = (this.$auth.can('solicitar_autorizacion_estudiante') || this.$auth.can('solicitar_autorizacion_profesor') || this.$auth.can('solicitar_autorizacion_todos') || this.$auth.can('solicitar_autorizacion_empleado') || this.$auth.can('solicitar_autorizacion_especial') || this.$auth.can('solicitar_autorizacion_visitante')) ? true : false;
    var arregloSeleccion = JSON.stringify(this.seleccionados);

    if (this.datosGenerador.CODIGO == null) {
      if (autorizadorCompleto) {
        this.datosGenerador.CODIGO = "ADMIN"
      } else {

        this.cargandoRegistrosTotales = false;
        this.$bvToast.toast(
          'El usuario actual no cuenta con los permisos suficientes o no se ha encontrado una identificación válida',
          {
            title: 'Error al solicitar',
            variant: 'danger',
            autoHideDelay: 5000,
          }
        )

        this.modalDesautoriza = false;
        return;

      }
    }

    let response = await axios.post(url.create('/internal/solicitudes/denegar'),
      {
        "registros": arregloSeleccion,
        "admin": autorizadorCompleto,
        "datosGenerador": this.datosGenerador,
      }
    );

    this.insertRegistros = response.data;

    if (this.insertRegistros.estado) {

      this.limpiarErrores();
      this.uncheckAll('GENERADAS');
      this.registrosGeneradas = [];
      this.seleccionados = [];

      this.$bvToast.toast(
        'Se han eliminado las solicitudes correctamente',
        {
          title: 'Registros eliminados',
          variant: 'success',
          autoHideDelay: 5000,
        }
      )


    } else {

      this.$bvToast.toast(
        'Error al eliminar las solicitudes',
        {
          title: 'Error al eliminar',
          variant: 'danger',
          autoHideDelay: 5000,
        }
      )

    }

  }


  // Funcion para cargar cualquier registro de cualquier tipo
  public async cargarDatosBusqueda(registroTipo) {

    var autorizadorCompleto = this.$auth.can('solicitar_autorizacion_todos');

    this.limpiarErrores();
    var registros = [];
    var parametros: any = {};

    if (registroTipo == "ESTUDIANTE") {
      this.registrosEstudiantes = [];
      this.cargandoEstudiantes = true
      parametros = this.filtroEstudiante

    } else if (registroTipo == "DOCENTE") {
      this.registrosDocentes = [];
      this.cargandoDocentes = true;
      parametros = this.filtroDocente

    } else if (registroTipo == "EMPLEADO") {
      this.registrosEmpleados = [];
      this.cargandoEmpleados = true;
      parametros = this.filtroEmpleado

    } else if (registroTipo == "ESPECIAL") {
      this.registrosEspeciales = [];
      this.cargandoEspeciales = true;
      parametros = this.filtroEspecial

    } else if (registroTipo == "VISITANTE") {
      this.registrosVisitantes = [];
      this.cargandoVisitantes = true;
      parametros = this.filtroVisitante

    } else if (registroTipo == "GENERADAS") {
      this.registrosGeneradas = [];
      this.cargandoGeneradas = true;
      parametros = this.filtroGeneradas

    }

    this.checkNrc = null
    if ((parametros.periodo && !parametros.nrc) || (parametros.nrc && !parametros.periodo)) {
      this.checkNrc = false
      this.limpiarCargando(registroTipo)
      return
    }

    try {

      if (this.datosGenerador.CODIGO == null) {
        await this.cargarGenerador();
      }

      if (this.datosGenerador.CODIGO == null) {

        if (autorizadorCompleto) {
          this.datosGenerador.CODIGO = "ADMIN"
        } else {

          this.$bvToast.toast(
            'El usuario actual no cuenta con los permisos suficientes o no se ha encontrado una identificación válida',
            {
              title: 'Error al solicitar',
              variant: 'danger',
              autoHideDelay: 5000,
            }
          )

          throw "Permisos insuficientes";

        }
      }

      var response;

      parametros["admin"] = autorizadorCompleto
      parametros["codigoSolicitante"] = this.datosGenerador.CODIGO

      if (registroTipo == "ESTUDIANTE") {
        response = await axios.get(url.create('/internal/autorizaciones/tipo/ESTUDIANTE'), { params: parametros });
      } else if (registroTipo == "DOCENTE") {
        response = await axios.get(url.create('/internal/autorizaciones/tipo/DOCENTE'), { params: parametros });
      } else if (registroTipo == "EMPLEADO") {
        response = await axios.get(url.create('/internal/autorizaciones/tipo/EMPLEADO'), { params: parametros });
      } else if (registroTipo == "ESPECIAL") {
        response = await axios.get(url.create('/internal/autorizaciones/tipo/ESPECIAL'), { params: parametros });
      } else if (registroTipo == "VISITANTE") {
        response = await axios.get(url.create('/internal/autorizaciones/tipo/VISITANTE'), { params: parametros });

      } else if (registroTipo == "GENERADAS") {
        parametros["tipoSolicitud"] = "DESAUTORIZA"
        response = await axios.get(url.create('/internal/solicitudes/GENERADAS'), { params: parametros });
      }

      registros = response.data

    } catch (error) {
      console.error(error);
    }


    if (registroTipo == "ESTUDIANTE") {
      this.registrosEstudiantes = registros;
    } else if (registroTipo == "DOCENTE") {
      this.registrosDocentes = registros;
    } else if (registroTipo == "EMPLEADO") {
      this.registrosEmpleados = registros;
    } else if (registroTipo == "ESPECIAL") {
      this.registrosEspeciales = registros;
    } else if (registroTipo == "VISITANTE") {
      this.registrosVisitantes = registros;
    } else if (registroTipo == "GENERADAS") {
      this.registrosGeneradas = registros;
    }
    this.limpiarCargando(registroTipo)

  }

  public limpiarCargando(registroTipo) {
    if (registroTipo == "ESTUDIANTE") {
      this.cargandoEstudiantes = false
    } else if (registroTipo == "DOCENTE") {
      this.cargandoDocentes = false;
    } else if (registroTipo == "EMPLEADO") {
      this.cargandoEmpleados = false;
    } else if (registroTipo == "ESPECIAL") {
      this.cargandoEspeciales = false;
    } else if (registroTipo == "VISITANTE") {
      this.cargandoVisitantes = false;
    } else if (registroTipo == "GENERADAS") {
      this.cargandoGeneradas = false;
    }
  }


  public async cargarGenerador() {
    try {
      let responsePersonal = await axios.get(
        url.create('/internal/vistas/personal')
      );
      this.datosGenerador = await responsePersonal.data ?? {}

    } catch (error) {
      console.log("Error al traer el registro de la vista");
      this.datosGenerador = {}
    }

  }


  @Watch('page')
  public pageChange(val) {
    this.cargarGenerador();
  }

  created() {
    this.cargarGenerador();
  }

}
</script>

<style>
.tab-content {
  background-color: #ffffff;
}
</style>